import { useState } from 'react';
import { useLoginMutation } from '../../../store/api/api';
import { Button } from '../../pieces/Button';

export function LoginForm() {
  const [login, { isLoading, isError, error }] = useLoginMutation();
  const [formState, setFormState] = useState({
    logindialogemail: '',
    logindialogpassword: '',
  });

  const handleChange = ({ target: { name, value } }) =>
    setFormState((prev) => ({ ...prev, [name]: value }));

  const canSubmit = Object.values(formState).every(Boolean) && !isLoading;

  function closeModal() {
    const loginDialog = document.getElementById('loginDialog');
    loginDialog.close();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (canSubmit) {
      await login({
        email: formState.logindialogemail,
        password: formState.logindialogpassword,
      }).unwrap();
      closeModal();
    }
  };

  const handleCancelButton = () => {
    closeModal();
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="my-2 pb-2">
        <h3 className="my-2 text-lg font-medium">Login</h3>
        <p>to react or create a thread</p>
        {isError && (
          <p id="errorMessage" className="text-red-500">
            {error.message}
          </p>
        )}
      </div>
      <fieldset className="flex flex-col space-y-4">
        <div className="relative flex flex-col">
          <input
            type="email"
            id="logindialogemail"
            name="logindialogemail"
            onChange={handleChange}
            className="border-1 peer block w-full appearance-none rounded-lg border-gray-300 bg-transparent px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-indigo-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-indigo-500"
            placeholder=" "
          />
          <label
            htmlFor="logindialogemail"
            className="absolute top-2 left-1 z-10 origin-[0] -translate-y-4 scale-75 transform bg-gray-100 px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-indigo-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-indigo-500"
          >
            Email
          </label>
        </div>
        <div className="relative flex flex-col">
          <input
            type="password"
            id="logindialogpassword"
            name="logindialogpassword"
            onChange={handleChange}
            className="border-1 peer block w-full appearance-none rounded-lg border-gray-300 bg-transparent px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-indigo-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-indigo-500"
            placeholder=" "
          />
          <label
            htmlFor="logindialogpassword"
            className="absolute top-2 left-1 z-10 origin-[0] -translate-y-4 scale-75 transform bg-gray-100 px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-indigo-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-indigo-500"
          >
            Password
          </label>
        </div>
        <div className="flex flex-row-reverse items-center gap-2">
          <Button
            size="base"
            variant="primary"
            type="submit"
            disabled={!canSubmit}
          >
            {isLoading ? 'Submitting...' : 'Submit'}
          </Button>
          <Button
            size="base"
            variant="tertiary"
            type="button"
            onClick={handleCancelButton}
          >
            Cancel
          </Button>
        </div>
      </fieldset>
    </form>
  );
}
